import { List } from "immutable";
import _ from "lodash";

export default {
  /*=========================================================================================
   Map操作系 Mutations
  ==========================================================================================*/
  SET_JUMP_TO: (state, payload) => {
    state.jumpTo = payload;
  },
  SET_MAP_STYLE(state, payload) {
    state.mapStyle = payload;
  },
  SET_JUMP_TO_MAP: (state, payload) => {
    state.jumpToMap = payload;
  },

  /*=========================================================================================
   船舶詳細系 Mutations
  ==========================================================================================*/
  SET_SHOW_VESSEL_DETAIL: (state, payload) => {
    state.showVesselDetail = payload;
  },
  SET_VESSEL_DETAIL: (state, payload) => {
    state.vesselDetail = payload;
  },
  SET_VESSEL_PICTURES: (state, payload) => {
    state.vesselPictures = payload;
  },
  SET_VESSEL_CAMERAS: (state, payload) => {
    state.vesselCameras = payload;
  },
  PUSH_VESSEL_CAMERAS: (state, payload) => {
    state.vesselCameras.push(payload);
  },
  SET_VESSEL_RADARS: (state, payload) => {
    state.vesselRadars = payload;
  },
  PUSH_VESSEL_RADARS: (state, payload) => {
    state.vesselRadars.push(payload);
  },
  SET_UNSUBSCRIBES: (state, payload) => {
    state.unsubscribes = payload;
  },
  SET_VESSEL_DETAIL_INFO: (state, payload) => {
    state.vesselDetailInfo = payload;
  },
  SET_VESSEL_DETAIL_POSITION: (state, payload) => {
    state.vesselDetailPosition = payload;
  },
  SET_COUNTRY_CODE(state, payload) {
    state.countryCodes = payload;
  },

  /*=========================================================================================
   自社船系 Mutations
  ==========================================================================================*/
  SET_OWN_VESSELS(state, payload) {
    state.ownVessels = payload;
  },
  SET_OWN_VESSEL_POSITION: (state, payload) => {
    state.ownVesselPosition = state.ownVesselPosition.set(payload.vesselId, {
      vesselInfo: payload.vesselInfo,
      position: payload.position,
      ais: payload.ais,
    });
  },
  SET_OWN_VESSEL_POINT_FEATURE_COLLECTION: (state, payload) => {
    state.ownVesselPointFeatureCollection = payload;
  },
  SET_OWN_VESSEL_POLYGON_FEATURE_COLLECTION: (state, payload) => {
    state.ownVesselPolygonFeatureCollection = payload;
  },
  SET_OWN_VESSEL_VECTOR_FEATURE_COLLECTION: (state, payload) => {
    state.ownVesselVectorFeatureCollection = payload;
  },
  SET_OWN_VESSEL_DISPLAY_DURATION_TIME: (state, time) => {
    state.ownVesselDisplayDurationTime = time;
  },

  /*=========================================================================================
   選択船舶系 Mutations
  ==========================================================================================*/
  ADD_MONITORING_VESSELS(state, payload) {
    state.monitoringVessels.push(payload);
  },
  SET_SELECTED_VESSELS(state, payload) {
    state.monitoringVessels = payload;
  },
  SET_MONITORING_STATUS: (state, payload) => {
    state.monitoringState = payload;
  },
  SET_SELECTED_VESSEL_POSITION: (state, payload) => {
    state.selectedVesselPosition = state.selectedVesselPosition.set(
      payload.vesselId,
      {
        position: payload.position,
        ais: payload.ais,
      },
    );
  },
  SET_SELECTED_VESSEL_POINT_FEATURE_COLLECTION: (state, payload) => {
    state.selectedVesselPointFeatureCollection = payload;
  },
  SET_SELECTED_VESSEL_POLYGON_FEATURE_COLLECTION: (state, payload) => {
    state.selectedVesselPolygonFeatureCollection = payload;
  },
  SET_SELECTED_VESSEL_VECTOR_FEATURE_COLLECTION: (state, payload) => {
    state.selectedVesselVectorFeatureCollection = payload;
  },
  REMOVE_SELECTED_VESSEL_POSITION: (state, vesselId) => {
    let selectedVesselPosition = state.selectedVesselPosition.remove(vesselId);
    state.selectedVesselPosition = selectedVesselPosition;
  },
  SET_IS_NEW_SELECTED_VESSEL: (state, payload) => {
    state.isNewSelectedVessel = payload;
  },

  /*=========================================================================================
   検索系 Mutations
  ==========================================================================================*/
  ADD_SELECTED_VESSELS: (state, payload) => {
    state.vesselDetail.push(payload);
  },
  ADD_VESSEL_SEARCH_RESULT: (state, payload) => {
    state.searchResult.vessel.data.push(payload);
  },
  SET_VESSEL_SEARCH_RESULT: (state, payload) => {
    state.searchResult.vessel.data = payload;
  },

  /*=========================================================================================
   プロット系 Mutations
  ==========================================================================================*/
  SET_SHOW_PLOT_DETAIL: (state, payload) => {
    state.showPlotDetail = payload;
  },
  SET_PLOT_DETAIL: (state, payload) => {
    state.plotDetail = payload;
  },
  SET_SHOW_PRIVATE_PLOT_DETAIL: (state, payload) => {
    state.showPrivatePlotDetail = payload;
  },
  SET_PRIVATE_PLOT_DETAIL: (state, payload) => {
    state.privatePlotDetail = payload;
  },

  /*=========================================================================================
   車両系 Mutations
  ==========================================================================================*/
  SET_SELECTED_VEHICLE: (state, payload) => {
    state.selectedVehicle = payload;
  },

  /*=========================================================================================
   航跡系 Mutations
  ==========================================================================================*/
  SET_WAKES: (state, payload) => {
    state.wakes = state.wakes.set(payload.vesselId, List(payload.wakes));
  },
  SET_OLDEST_VESSEL_ID: (state, vesselId) => {
    state.oldestVesselId = vesselId;
  },
  SET_WAKES_LINE_FEATURE_COLLECTION: (state, payload) => {
    state.wakeLineFeatureCollection = payload;
  },
  MERGE_WAKES: (state, payload) => {
    if (payload) {
      let wakes = state.wakes;
      let wake = wakes.get(payload.vesselId);
      wake = wake.push(payload.data);
      wakes = wakes.set(payload.vesselId, wake);
      state.wakes = wakes;
    }
  },
  REMOVE_OLDEST_WAKE: (state, vesselId) => {
    let wakes = state.wakes;
    state.wakes = wakes.remove(vesselId);
  },
  REMOVE_WAKE: (state, vesselId) => {
    if (vesselId) {
      let wakes = state.wakes;
      state.wakes = wakes.remove(vesselId);
    }
  },

  /*=========================================================================================
   フィルター系 Mutations
  ==========================================================================================*/
  SET_FILTER_VESSELS: (state, payload) => {
    state.filterVessels = payload;
  },
  SET_FILTER_PLOTS: (state, payload) => {
    state.filterPlots = payload;
  },
  SET_FILTER_PRIVATE_PLOTS: (state, payload) => {
    state.filterPrivatePlots = payload;
  },
  SET_FILTER_NAVIGATIONS: (state, payload) => {
    state.filterNavigations = payload;
  },
  SET_FILTER_RADAR_GRID: (state, payload) => {
    state.filterRadarGrid = payload;
  },

  /*=========================================================================================
   右サイドバー Mutations
  ==========================================================================================*/
  SET_ACTIVE_LAYERS_SIDEBAR: (state, payload) => {
    state.activeLayersSidebar = payload;
  },
  SET_ACTIVE_SEARCH_SIDEBAR: (state, payload) => {
    state.activeSearchSidebar = payload;
  },
  SET_ACTIVE_OWN_VESSEL_SIDEBAR: (state, payload) => {
    state.activeOwnVesselSidebar = payload;
  },
  SET_ACTIVE_SELECT_VESSEL_SIDEBAR: (state, payload) => {
    state.activeSelectVesselSidebar = payload;
  },
  SET_ACTIVE_FILTER_SIDEBAR: (state, payload) => {
    state.activeFilterSidebar = payload;
  },
  SET_ACTIVE_PLOT_SIDEBAR: (state, payload) => {
    state.activePlotSidebar = payload;
  },
  SET_ACTIVE_PRIVATE_PLOT_SIDEBAR: (state, payload) => {
    state.activePrivatePlotSidebar = payload;
  },
  SET_ACTIVE_WEATHER_SIDEBAR: (state, payload) => {
    state.activeWeatherSidebar = payload;
  },
  SET_ACTIVE_VEHICLE_SIDEBAR: (state, payload) => {
    state.activeVehicleSidebar = payload;
  },
  SET_ACTIVE_VESSEL_EQUIPMENT_BASE_STATION_SIDEBAR: (state, payload) => {
    state.activeVesselEquipmentBaseStationSidebar = payload;
  },
  SET_ACTIVE_SETTINGS_SIDEBAR: (state, payload) => {
    state.activeSettingsSidebar = payload;
  },
  SET_ACTIVE_ANCHOR_VESSEL_SIDEBAR: (state, payload) => {
    state.activeAnchorVesselSidebar = payload;
  },
  SET_LAST_VESSEL_POSITIONS: (state, payload) => {
    state.lastVesselPositions.push(payload);
  },
  REMOVE_LAST_VESSEL_POSITION: (state, vesselId) => {
    state.lastVesselPositions = state.lastVesselPositions.filter((vessel) => {
      return vessel.vessel_id !== vesselId;
    });
  },
  /*=========================================================================================
   POLARIS系 Mutations
  ==========================================================================================*/
  SET_METOCEAN_INITIAL_DATETIME: (state, payload) => {
    state.metoceanInitialDatetime = payload;
  },
  SET_METOCEAN_CURRENT_DATETIME: (state, payload) => {
    state.weatherCurrentDatetime = payload;
  },
  SET_OLD_WEATHER_SOURCE_LAYER: (state, payload) => {
    state.oldWeatherSourceLayerId = payload;
  },
  SET_CURRENT_WEATHER_SOURCE_LAYER: (state, payload) => {
    state.currentWeatherSourceLayerId = payload;
  },
  SET_UPDATE_METOCEAN_SOURCE_LAYER: (state, payload) => {
    state.updateMetoceanSourceLayer = payload;
  },
  SET_UPDATE_CONTOUR_SOURCE_LAYER: (state, payload) => {
    state.updateContourSourceLayer = payload;
  },
  SET_SELECTED_METOCEAN_ELEMENT: (state, payload) => {
    state.selectedMetoceanElement = payload;
  },
  REMOVE_WEATHER_ELEMENT: (state) => {
    state.selectedMetoceanElement = null;
  },
  SET_SHOW_WEATHER_MENU: (state, payload) => {
    state.showWeatherMenu = payload;
  },
  SET_SHOW_CONTOUR: (state, payload) => {
    state.showContour = payload;
  },
  SET_SHOW_METOCEAN_VALUE: (state, payload) => {
    state.showMetoceanValue = payload;
  },
  SET_SHOW_METOCEAN_GRID: (state, payload) => {
    state.showMetoceanGrid = payload;
  },
  SET_OFFING_WAVE_POINTS: (state, payload) => {
    state.offingWavePoints = payload;
  },
  SET_DIALOG_OFFING_WAVE_POINT_INPUT_FORM: (state, payload) => {
    state.dialogOffingWavePointInputForm = payload;
  },
  SET_OFFING_WAVE_POINT_INPUT_VALUES: (state, payload) => {
    state.offingWavePointInputValues = payload;
  },
  SET_OFFING_WAVE_POINT: (state, payload) => {
    state.offingWavePoints = payload;
  },
  ADD_OFFING_WAVE_POINT: (state, payload) => {
    state.offingWavePoints.push(payload);
  },
  UPDATE_OFFING_WAVE_POINT: (state, payload) => {
    let index = state.offingWavePoints.findIndex(
      (point) => point.pointId === payload.pointId,
    );
    let _offingWavePoints = _.cloneDeep(state.offingWavePoints);
    _offingWavePoints[index] = payload;
    state.offingWavePoints = _offingWavePoints;
  },
  REMOVE_OFFING_WAVE_POINT: (state, pointId) => {
    let points = state.offingWavePoints.filter((v) => {
      return pointId !== v.pointId;
    });
    points.map((v, i) => {
      v.pointId = i + 1;
    });
    state.offingWavePoints = points;
  },
  SET_TYPHOON_INFO_LIST: (state, payload) => {
    state.typhoonInfoList = payload;
  },
  SET_TYPHOON_LAYER_VISIBILITY: (state, payload) => {
    state.typhoonLayerVisibility = payload;
  },
  SET_TIMESYNC_MODE: (state, payload) => {
    state.isTimeSyncMode = payload;
  },

  /*=========================================================================================
   CAMERA系 Mutations
  ==========================================================================================*/
  SET_SELECTED_FIXED_POINT_CAMERA: (state, payload) => {
    state.selectedFixedPointCamera = payload;
  },

  /*=========================================================================================
   お気に入りグループ系 Actions
  ==========================================================================================*/
  SET_GROUP_LIST: (state, payload) => {
    const favoriteKey = payload.favoriteKey;
    const groupList = payload.groupList;
    state.favoriteList[Number(favoriteKey)].groupList.splice(0);
    groupList.forEach((group) => {
      state.favoriteList[Number(favoriteKey)].groupList.push(group);
    });
  },
  SET_FAVORITE_LABEL: (state, payload) => {
    const favoriteKey = payload.favoriteKey;
    const label = payload.label;
    state.favoriteList[favoriteKey].label = label;
  },
  ADD_GROUP_UNSUBSCRIBES(state, data) {
    state.groupUnsubscribes.push(data);
  },
  UNSUBSCRIBE_GROUP(state) {
    if (state.groupUnsubscribes.length > 0) {
      state.groupUnsubscribes.forEach((unsubscribe) => {
        unsubscribe();
      });
    }
    state.groupUnsubscribes = [];
  },
  /*=========================================================================================
   リセット
  ==========================================================================================*/
  RESET_STATE(state, data) {
    Object.assign(state, data);
  },
};
